import { Component } from '@angular/core';
import { OrderService, SiteService } from '@app/_services';
import { Pagination } from '@app/_interfaces/pagination.interface';
import { ceil } from 'lodash';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { registerLocaleData, NgIf, NgFor, DatePipe } from '@angular/common';
import { TranslateHelper } from '@app/_helpers';
import { CurrencyFormatPipe } from '../../../../shared/pipes/currency-format.pipe';
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component';
import { MatIconModule } from '@angular/material/icon';
import { CurrencyConvertPipe } from '@app/shared/pipes';

@Component({
    selector: 'app-page-orders-list',
    templateUrl: './page-orders-list.component.html',
    styleUrls: ['./page-orders-list.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, NgFor, RouterLink, MatIconModule, PaginationComponent, DatePipe, CurrencyFormatPipe, TranslateModule, CurrencyConvertPipe]
})
export class PageOrdersListComponent {

    constructor(private orderService: OrderService,
        private route: ActivatedRoute,
        private router: Router,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        public siteService: SiteService) { }

    orders;
    paginationOrderCount;
    pagination: Pagination = {
        page: 1,
        limit: 10
    }
    paginationSubject$: Subject<any> = new Subject();
    ngOnInit() {
        this.orderService.getAll(this.pagination).subscribe((response) => {
            this.orders = response.data;
            this.paginationOrderCount = ceil(response.ordersCount / 10)
        });

        this.paginationSubject$.pipe(
            debounceTime(1000),
            switchMap(() => {
                // this.updateUrl();
                return this.orderService.getAll(this.pagination);
            })
        ).subscribe(response => {
            this.orders = response.data;

        });
    }

    updateOrdersList(pageNumber) {
        this.pagination.page = pageNumber;
        this.paginationSubject$.next();
    }

    updateUrl() {
        this.router.navigate(
            [],
            {
                relativeTo: this.route,
                queryParams: this.pagination,
                queryParamsHandling: '',
            });
    }

    orderDetails(order){this.router.navigate(['/account/orders/' , order.orderId])}
}
